import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BreadCrumbComponent} from './bread-crumb.component';


@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule
  ],
  declarations: [BreadCrumbComponent
  ],
  exports: [
    BreadCrumbComponent
  ],
  providers: []
})

export class BreadCrumbModule {
}
